<template>
  <div>
    <personel-view-search-panel @search="search" :accessTo="3" />

    <box class="mt-2" :title="$t('vacationList')">
      <div class="vacationList">
        <div v-if="list.length > 0">
          <person-vacation-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClickVacation="onClickVacation"
          />
          <person-vacation-list-mob
            @onClickVacation="onClickVacation"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <!-- <div v-else>
          <EmptyList />
        </div> -->
      </div>
    </box>
  </div>
</template>

<script>
import PersonVacationListMob from "../../components/functionality/periodDetails/PersonVacationList/PersonVacationListMob.vue";
import PersonVacationListWeb from "../../components/functionality/periodDetails/PersonVacationList/PersonVacationListWeb.vue";
// import PersonelViewSearchPanel from "../../components/requestManagement/PersonelViewSearchPanel.vue";
import PersonelViewSearchPanel from "../../components/requestManagement/PersonelViewSearchPanelWhitParam.vue";
export default {
  components: {
    PersonelViewSearchPanel,
    PersonVacationListWeb,
    PersonVacationListMob,
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    search(searchParams) {
      const params = new URLSearchParams();
      params.append("beginDate", searchParams.beginDate);
      params.append("endDate", searchParams.endDate);
      params.append("searchKind", searchParams.searchKind);
      params.append("perno", searchParams.perno);
      debugger

      this.$store.dispatch("PersonVacationList", { params }).then((result) => {
        //console.log(result);
        if (result.type === "success") {
          this.list = result.data;
        } else {
          this.list = [];
        }
      });
    },
    onClickVacation(){},
  },
};
</script>

<style>
</style>